module.exports = __webpack_public_path__ + "static/media/galerija_2014 (36).5ed858ef.jpg";